import { ArrowLeftIcon } from '@heroicons/react/solid'
import { IconButton } from '@sushiswap/ui/components/iconbutton'
import Link from 'next/link'
import { NextSeo } from 'next-seo'
import React from 'react'

import { Layout } from '../../../components'

const SingleStream = () => {
  return (
    <>
      <NextSeo title="New Stream" />
      <Layout>
        <Link
          className="group flex gap-4 items-center mb-2"
          href={{
            pathname: '/create',
          }}
          shallow={true}
        >
          <IconButton size="sm" icon={ArrowLeftIcon} name="Back" />
          <span className="group-hover:opacity-[1] transition-all opacity-0 text-sm font-medium">Go back</span>
        </Link>
        <h1>Sushi Pay is in the process of being deprecated. New stream creation has been disabled.</h1>
      </Layout>
    </>
  )
}

export default SingleStream
